<template>
  <div id="the-good">
    <b-container class="the-good-container">
      <div class="gitg-logo-container" v-if="global.screenWidth > 992">
        <img
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/pablo/thegood/Latino-Policy-Forum.jpg')
          "
        />
      </div>
      <div class="good-content">
        <div class="header-align">
          <Header v-if="!spanish" title="The Good" :alignBarStart="global.screenWidth > 992" />
          <Header v-if="spanish" title="El Bien" :alignBarStart="global.screenWidth > 992" />
        </div>
        <img
          v-if="global.screenWidth <= 992"
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/pablo/thegood/Latino-Policy-Forum.jpg')
          "
        />
        <p v-if="!spanish">
          The mission of the Latino Policy Forum is to build the power, influence and
          leadership of the Latino community through collective action to transform
          public policies that ensure the well-being of our community and society as
          a whole. 
          <br><br>
          Since 1988, the organization has provided a leading voice in
          housing – advocating for equitable participation and equal access to a
          wide range of housing options for Latinos in the Chicago Metropolitan
          region. 
          <br><br>
          To learn more the Latino Policy Forum, visit:
          <a href="https://www.latinopolicyforum.org/" target="_blank" style="color: #ce0e2d">
          www.latinopolicyforum.org.
          </a>
        </p>
        <p v-if="spanish">
          La misión del Latino Policy Forum es construir el poder, la influencia y el liderazgo
          de la comunidad Latina a través de la acción colectiva para transformar políticas públicas
          que aseguren el bienestar de nuestra comunidad y de la sociedad en su conjunto. 
          <br><br>
          Desde 1988, la organización ha sido una de las principales voces en materia de vivienda,
          abogando por la participación equitativa y la igualdad de acceso a una amplia gama de opciones
          de vivienda para los latinos en la región metropolitana de Chicago. 
          <br><br>
          Para más información sobre el Latino Policy Forum, por favor visita:
          <a href="https://www.latinopolicyforum.org/" target="_blank" style="color: #ce0e2d">
          www.latinopolicyforum.org.
          </a>
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import { mapState } from "vuex";
export default {
  name: "TheGood",
  components: {
    Header,
  },
  props: ["spanish"],
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-good {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-good-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    @media (max-width: 1050px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .gitg-logo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    height: 100%;
    @media (max-width: 1050px) {
      align-items: center;
    }
  }
  .header-align {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 100px;
    width: auto;
    @media (max-width: 1050px) {
      justify-content: center;
    }
  }
  .gitg-logo {
    width: 298px;
    max-width: 90%;
    object-fit: contain;
    @media (max-width: 1050px) {
      margin-bottom: 37px;
    }
  }
  .good-content {
    width: 670px;
    max-width: 75%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (max-width: 1050px) {
      align-items: center;
      width: 100%;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: 1050px) {
      text-align: center;
    }
  }

  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
